import { BASE_URL_ONLINE_DOCS } from '../../base/constants/cgi-base';
// 用户信息
export var USER_INFO = "".concat(BASE_URL_ONLINE_DOCS, "user_info");
// 获取会员信息
export var GET_VIP_ALL = "".concat(BASE_URL_ONLINE_DOCS, "vip_all");
// 新用户标签Flag
export var USER_FLAG = "".concat(BASE_URL_ONLINE_DOCS, "user_flag");
// 是否有绑定信息和关注公众号信息
export var USER_INFO_CHECK = "".concat(BASE_URL_ONLINE_DOCS, "user_info/check");
